export function generateEditableRawAssetDetails(rawAssetDetails, metaTagNameList) {
  const rawAssetDetailsCopy = JSON.parse(JSON.stringify(rawAssetDetails));
  metaTagNameList.forEach((tag) => {
    if (rawAssetDetailsCopy[tag] === undefined) {
      rawAssetDetailsCopy[tag] = '';
    }
  });
  return rawAssetDetailsCopy;
}
